import { loadConfig as o } from "../../../shared/data/configuration/state/index.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import { loadPhoneInfo as r } from "../../../shared/data/csr/state/index.js";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import { getLocationAsync as t } from "../../../shared/data/location/state/index2.js";
import { loadMenuCategories as m } from "../../../shared/data/navigation/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import { loadAvailableContracts as i } from "../../../search/state/index.js";
import "../../../search/state/index2.js";
import { getUserAsync as p } from "../../../shared/data/user/state/index.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
function D() {
  o(), p(), r(), t(), m(), i();
}
export {
  D as loadStoreData
};
//# sourceMappingURL=index.js.map
